import * as $ from 'jquery';
export const Footer = () => {
    $('.js-scroll-to-top').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });
};
